import * as Types from '../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoApplySetupEntryModeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetAutoApplySetupEntryModeQuery = {
    __typename?: 'Query';
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              mode?: Types.AutoApplyMode | null | undefined;
              autoApplyStatus?: Types.AutoApplyStatus | null | undefined;
          }
        | null
        | undefined;
};

export const GetAutoApplySetupEntryModeDocument = gql`
    query GetAutoApplySetupEntryMode {
        autoApplyInfo {
            mode
            autoApplyStatus
        }
    }
`;

/**
 * __useGetAutoApplySetupEntryModeQuery__
 *
 * To run a query within a React component, call `useGetAutoApplySetupEntryModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplySetupEntryModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplySetupEntryModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAutoApplySetupEntryModeQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplySetupEntryModeQuery,
        GetAutoApplySetupEntryModeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAutoApplySetupEntryModeQuery,
        GetAutoApplySetupEntryModeQueryVariables
    >(GetAutoApplySetupEntryModeDocument, options);
}
export function useGetAutoApplySetupEntryModeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplySetupEntryModeQuery,
        GetAutoApplySetupEntryModeQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAutoApplySetupEntryModeQuery,
        GetAutoApplySetupEntryModeQueryVariables
    >(GetAutoApplySetupEntryModeDocument, options);
}
export function useGetAutoApplySetupEntryModeSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplySetupEntryModeQuery,
              GetAutoApplySetupEntryModeQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplySetupEntryModeQuery,
        GetAutoApplySetupEntryModeQueryVariables
    >(GetAutoApplySetupEntryModeDocument, options);
}
export type GetAutoApplySetupEntryModeQueryHookResult = ReturnType<
    typeof useGetAutoApplySetupEntryModeQuery
>;
export type GetAutoApplySetupEntryModeLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplySetupEntryModeLazyQuery
>;
export type GetAutoApplySetupEntryModeSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplySetupEntryModeSuspenseQuery
>;
export type GetAutoApplySetupEntryModeQueryResult = Apollo.QueryResult<
    GetAutoApplySetupEntryModeQuery,
    GetAutoApplySetupEntryModeQueryVariables
>;
